import Footer from '@/components/common/Footer';
import ExchangeRateModal from '@/components/fxReceipt/ExchangeRateModal';
import FXReceiptList from '@/components/fxReceipt/FXReceiptList';
import FXReceiptListShort from '@/components/fxReceipt/FXReceiptListShort';
import ReceiptCalculator from '@/components/fxReceipt/ReceiptCalculator';
import React, { useState } from 'react';
import styled from 'styled-components';
import CHEVRON_LEFT_BLACK from '@/assets/common/chevron_left_black.png';
import CHEVRON_RIGHT_BLACK from '@/assets/common/chevron_right_black.png';
import EXCHANGE from '@/assets/fx/exchange.png';
import { getExchangeRate } from '@/util/exchangeRate';
import FXReceiptSummary from '@/components/fxReceipt/FXReceiptSummary';
import { useGetForeignCurrencyHistory } from '@/hooks/useGetForeignCurrencyHistory';
import FXReceiptViewSelector from '@/components/fxReceipt/FXReceiptViewSelector';
import FXReceiptDateSelector from '@/components/fxReceipt/FXReceiptDateSelector';

function FXReceipt() {
  const [isExchangeRateModalOpen, setIsExchangeRateModalOpen] = useState(false);
  const [isShowDetailTable, setIsShowDetailTable] = useState(false);
  const [currentRate, setCurrentRate] = useState(getExchangeRate());
  const { setPageNumber } = useGetForeignCurrencyHistory();
  if (isShowDetailTable) {
    return (
      <FXReceiptWrapper>
        <Container>
          <TopSectionWrapper>
            <TitleSection>
              <BackButton
                onClick={() => {
                  setIsShowDetailTable(false);
                }}
              >
                <BtnIcon src={CHEVRON_LEFT_BLACK} alt='left' />
              </BackButton>
              <SubTitle>현금 수납 내역 (현금 영수증 발행 내역)</SubTitle>
            </TitleSection>
            <SortingWrapper>
              <FXReceiptViewSelector />
              <FXReceiptDateSelector
                isRefundDetail
                setPageNumber={setPageNumber}
              />
            </SortingWrapper>
          </TopSectionWrapper>
          <FXReceiptSummary />
          <FXReceiptList />
        </Container>
        <Footer />
      </FXReceiptWrapper>
    );
  }

  return (
    <FXReceiptWrapper>
      <Container>
        <TopSection>
          <Header>
            <Title>현금 수납하기</Title>
            <ExchangeRateButton
              onClick={() => setIsExchangeRateModalOpen(true)}
            >
              <span>환율 수정하기</span>
              <IconExchange src={EXCHANGE} />
            </ExchangeRateButton>
          </Header>

          <ReceiptCalculator />
        </TopSection>
        <Wrapper>
          <TableTitleSection>
            <Title>현금 수납 내역 (현금 영수증 발행 내역)</Title>
            <FXReceiptDateSelector
              isRefundDetail
              setPageNumber={setPageNumber}
            />
          </TableTitleSection>
          <FXReceiptSummary />
          <FXReceiptListShort />
          <MoreTableButton
            onClick={() => {
              setIsShowDetailTable(true);
            }}
          >
            더보기
            <IconRight src={CHEVRON_RIGHT_BLACK} alt='right' />
          </MoreTableButton>
        </Wrapper>
        <ExchangeRateModal
          isOpen={isExchangeRateModalOpen}
          onClose={() => setIsExchangeRateModalOpen(false)}
          onSubmit={(rate) => {
            setCurrentRate(rate);
            setIsExchangeRateModalOpen(false);
          }}
          currentRate={currentRate}
        />
      </Container>
      <Footer />
    </FXReceiptWrapper>
  );
}

export default FXReceipt;

const FXReceiptWrapper = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 1080px;
  height: 100vh;
  flex: 1;
  overflow-y: scroll;
  background-color: #f8f9fa;
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  width: 100%;
  padding: 72px 40px 64px;
`;

const TopSection = styled.div`
  margin-bottom: 12px;
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
`;

const Title = styled.h1`
  color: var(--Mono-80, #3a3b3e);

  /* WebHead/21_BD */
  font-family: Pretendard, sans-serif;
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 150%; /* 31.5px */
  letter-spacing: -0.42px;
`;

const ExchangeRateButton = styled.button`
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 4px 12px;
  border-radius: 4px;
  border: 1px solid var(--Blue-100, #246cf6);
  background: #fff;
  color: var(--KTP-Blue-100, #246cf6);
  text-align: center;

  /* WebBody/14_MD */
  font-family: Pretendard, sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 150%; /* 21px */
  letter-spacing: -0.28px;
  cursor: pointer;

  &:hover {
    background: #f0f6ff;
  }
`;

const TableTitleSection = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  margin-bottom: 24px;
  position: relative;
`;

const MoreTableButton = styled.button`
  display: flex;
  align-items: center;
  align-self: flex-end;
  gap: 4px;
  color: var(--Mono-80, #3a3b3e);
  text-align: right;
  font-family: Pretendard, sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 150%; /* 24px */
  letter-spacing: -0.32px;
`;

const TitleSection = styled.div`
  display: flex;
  align-items: center;
`;

const SubTitle = styled.h3`
  font-size: ${(props) => props.theme.fontSize.regular};
  font-weight: ${(props) => props.theme.fontWeight.bold};
  line-height: ${(props) => props.theme.lineHeight.regular};
  color: ${(props) => props.theme.mono[80]};
`;
const BackButton = styled.button`
  width: 24px;
  height: 24px;
  padding: 0;
  margin-right: 4px;
`;

const BtnIcon = styled.img`
  width: 24px;
  height: 24px;
`;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 36px;
`;

const IconRight = styled.img`
  width: 16px;
  height: 16px;
`;

const IconExchange = styled.img`
  width: 18px;
  height: 18px;
`;

const SortingWrapper = styled.div`
  position: relative;
  display: flex;
  justify-content: flex-end;
  align-items: center;

  gap: 12px;
`;

const TopSectionWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 22px;
`;
